<template>
    <div
        class="slider-toggle-container form-group"
        :class="sliderContainerClass"
    >
        <label class="slider-toggle-title">{{ title }}</label>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: () => 'Title',
        },
        sliderContainerClass: {
            type: String,
            default: () => '',
        },
    },
}
</script>

<style lang="scss">
.slider-toggle-container {
    min-height: 100px;
    margin-bottom: 30px;
    .slider-toggle-title {
        margin-bottom: 10px;
    }
    .slider-toggle {
        margin-bottom: 14px;
    }
}
</style>
